<template>
    <div>
        <label :title="data.name">{{ data.name }}</label>
        <span :title="data.info">{{ data.info }}</span>
        <meter optimum="0" :low="data.low" :high="data.high" :value="data.value"></meter>
        <span :data-status="data.status">{{ data.percent }}</span>
    </div>
</template>

<script>
export default {
  props: [
    'data'
  ]
}
</script>

<style scoped>
div{
  display:flex;
  margin-bottom:1px
}
label{
  flex:1;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis
}
span{
  flex:inherit;
  margin-left:5px;
  color: grey;
  width:60px;
  white-space:nowrap;
  text-overflow:ellipsis
}
meter{
  flex:1;
  margin-left:5px;
}
meter::-webkit-meter-bar,
meter::-moz-meter-suboptimum{
  background: orange
}
span[data-status]{
  width:25px
}
span[data-status="2"]{
  color:green
}
span[data-status="1"]{
  color:orange
}
span[data-status="0"]{
  color:red
}
</style>
